import { AlpineComponentTryba } from '../../scripts/alpine/include/global';
import { activateAbTestByEvent } from '../../scripts/ab/registry';

// AB test 86c9ntj0b - Tunnel Devis v1 "votre demande en 2 mn" + avis vérifié dans le header du tunnel de devis

export default (): AlpineComponentTryba => ({
    init() {
        window.addEventListener('show-header-wording-and-reviews', () => {
            activateAbTestByEvent('show-header-wording-and-reviews');
            this.$store.ab.showHeaderWordingAndReviews = true;
        });
    },
});
